import { render, staticRenderFns } from "./JianKang_PainSpot_Survey.vue?vue&type=template&id=9e33b0da&scoped=true"
import script from "./JianKang_PainSpot_Survey.vue?vue&type=script&lang=js"
export * from "./JianKang_PainSpot_Survey.vue?vue&type=script&lang=js"
import style0 from "./JianKang_PainSpot_Survey.vue?vue&type=style&index=0&id=9e33b0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e33b0da",
  null
  
)

export default component.exports